import { gql } from '@apollo/client';

import { useHasZoomIntegrationQuery } from 'src/generated/mloop-graphql';

export const useHasZoomIntegration = () => {
  const { data } = useHasZoomIntegrationQuery();
  return data?.thisOrg?.integrations?.zoom?.active || data?.thisOrg?.integrations?.zoomCustom?.active;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const GQL_HAS_ZOOM_INTEGRATION = gql`
  query HasZoomIntegration {
    thisOrg {
      id
      integrations {
        id
        zoom {
          active
        }
        zoomCustom {
          active
        }
      }
    }
  }
`;
